
import ImgOne from '../assets/images/our-services/organic-food.webp'
import ImgTwo from '../assets/images/our-services/express-delivery.webp'
import ImgThree from '../assets/images/our-services/unforgable-taste.webp'

const ourServices = [
    {
      id: 1,
      img: ImgOne,
      name: 'Bio-Qualität',
      description:
        'Biologisch, rein und gesund – das ist der Kern unserer Philosophie. Wir glauben, dass die Qualität unserer Ernährung unsere Zukunft bestimmt. Deshalb setzen wir auf bewusste Entscheidungen für ein gesünderes Morgen.',
    },
    {
      id: 2,
      img: ImgTwo,
      name: 'Schnelle Lieferung',
      description:
        'Genieße eine schnelle und zuverlässige Lieferung durch unsere vertrauenswürdigen Partner. Ob spontaner Hunger oder geplante Bestellung – deine Pizza kommt frisch und pünktlich bei dir an, genau wie du es magst.',
    },
    {
      id: 3,
      img: ImgThree,
      name: 'Unvergesslicher Geschmack',
      description:
        'Unsere Mission: erstklassiger Service, unglaubliche Aromen und ein unvergessliches Genusserlebnis. Freu dich auf eine Geschmacksexplosion, die dir im Gedächtnis bleibt.',
    },
  ]

export default ourServices;